import React, { useState } from "react";
import { useNavigate, Link } from "react-router-dom";

export default function Kit({navigateWithTransition}) {




return (

<div className="Kit">




</div>

)

}